import { render, staticRenderFns } from "./FormSideNav.vue?vue&type=template&id=8b8ece6c&scoped=true&"
import script from "./FormSideNav.vue?vue&type=script&lang=js&"
export * from "./FormSideNav.vue?vue&type=script&lang=js&"
import style0 from "./FormSideNav.vue?vue&type=style&index=0&id=8b8ece6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8ece6c",
  null
  
)

export default component.exports